import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

const KYouthSectionTitle = ({ slogan, title, classes }) => {
  return (
    <div className={`section-title ${classes ? classes : ""}`}>
      <ScrollAnimation
        offset={1000}
        animateIn="fadeInUp"
        animateOut="fadeInOut"
        animateOnce={true}
      >
        <span
          className="pre-title"
          dangerouslySetInnerHTML={{ __html: slogan }}
        ></span>
      </ScrollAnimation>

      <ScrollAnimation
        offset={1000}
        animateIn="fadeInUp"
        animateOut="fadeInOut"
        animateOnce={true}
      >
        {title}
      </ScrollAnimation>
    </div>
  );
};
export default KYouthSectionTitle;
